import axios from 'axios';
import ReferralPointsRewardTable, {
  tableColumns
} from 'components/tables/ReferralPointsRewardTable';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { errorHandler } from 'helpers/response-utils';

const RewardReferralClaimTransactionList = () => {
  const [transaction, setTransaction] = useState([]);
  const token = localStorage.getItem('token');
  const [statusFilter, setStatusFilter] = useState('pending');
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });
  const [totalRecords, setTotalRecords] = useState(0);

  // if userId is passed in query string, filter by that userId
  const params = new URLSearchParams(window.location.search);
  const userId = params.get('userId');

  useEffect(() => {
    getList();
  }, [statusFilter, userId, pagination]);

  const getList = async () => {
    const url = `/referral-points-transactions`;

    let params: Record<string, any> = {
      page: pagination.pageIndex + 1,
      pageSize: pagination.pageSize
    };

    if (userId) {
      params = { ...params, userId };
    }

    const response = await axios.get(
      `${process.env.REACT_APP_ENDPOINT}${url}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: params
      }
    );
    errorHandler(response);
    if (response.data['status'] == 'error') {
      toast.error(response.data['message']);
      return false;
    }
    setTransaction(response.data['data']);
    setTotalRecords(response.data['totalRecords']);
  };

  const handlePaginationChange = (updater: any) => {
    const newState =
      typeof updater === 'function' ? updater(pagination) : updater;
    setPagination(newState);
  };

  const table = useAdvanceTable({
    data: transaction,
    columns: tableColumns,
    pageSize: pagination.pageSize,
    pagination: true,
    sortable: true,
    selection: false,
    initialState: {
      columnVisibility: {}
    },
    meta: {
      manualPagination: true,
      totalRecords: totalRecords,
      onPaginationChange: handlePaginationChange,
      pagination: pagination,
      getList: getList
    }
  });

  return (
    <div>
      <div className="mb-6">
        <AdvanceTableProvider {...table}>
          <Row className="g-3 justify-content-between mb-4">
            <Col xs="auto">
              <h2 className="mb-0">{totalRecords} Referral Points Reward </h2>
            </Col>
            <Col xs="auto"></Col>
          </Row>
          <ReferralPointsRewardTable />
        </AdvanceTableProvider>
      </div>
    </div>
  );
};

export default RewardReferralClaimTransactionList;
